import { render, staticRenderFns } from "./ProdWkStats.vue?vue&type=template&id=1fb48de2&"
import script from "./ProdWkStats.vue?vue&type=script&lang=js&"
export * from "./ProdWkStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports